/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, type RequestExtraParams, request } from '@/utils/request'
import type {
  AdsPositionQueryPositionPostData,
  AdsPositionQueryPositionPostPayload,
  AdsPositionSubmitPositionPostData,
  AdsPositionSubmitPositionPostPayload,
} from './data-contracts'

export type { ParamData, ReturnPromise } from '@/utils/request'

const baseUrl: string = '/sea_shell/leafy-seadragon'

/**
 * No description
 *
 * @tags AdsPositionApi
 * @name AdsPositionQueryPositionPost
 * @summary 查询运营位信息
 * @request POST:/adsPosition/queryPosition
 */
export function adsPositionQueryPositionPost(
  root: AdsPositionQueryPositionPostPayload,
  params: RequestExtraParams = {},
) {
  return request<AdsPositionQueryPositionPostData, any>({
    url: baseUrl + `/adsPosition/queryPosition`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags AdsPositionApi
 * @name AdsPositionSubmitPositionPost
 * @summary 运营位交互操作
 * @request POST:/adsPosition/submitPosition
 */
export function adsPositionSubmitPositionPost(
  root: AdsPositionSubmitPositionPostPayload,
  params: RequestExtraParams = {},
) {
  return request<AdsPositionSubmitPositionPostData, any>({
    url: baseUrl + `/adsPosition/submitPosition`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}
